export default __webpack_public_path__ + "//i/components/page-header//logo-version.png";